export default __webpack_public_path__ + "static/media/our-values-HEADER-Mobile.cea764be.jpg";